const allUserGroups = {
  usePayouts: 'USE_PAYOUTS',
  ACCOUNT_MANAGEMENT_FLOWS_V2: 'ACCOUNT_MANAGEMENT_FLOWS_V2',
  ACHIEVEMENTS_SECTION: 'ACHIEVEMENTS_SECTION',
  ACHIEVEMENTS_SECTION_PHASE2: 'ACHIEVEMENTS_SECTION_PHASE2',
  ACHIEVEMENTS_SECTION_POLLING: 'ACHIEVEMENTS_SECTION_POLLING',
  ADMIN_BANNED_USERNAMES_V2: 'ADMIN_BANNED_USERNAMES_V2',
  ADMIN_LOG_V2: 'ADMIN_LOG_V2',
  ANONYMOUS_ULTRA_PAGE_SPEED: 'ANONYMOUS_ULTRA_PAGE_SPEED',
  AUTO_PAYMENT: 'AUTO_PAYMENT',
  AWARDS_V2: 'AWARDS_V2',
  BACKGROUND_IMAGE_STATIC_RESOURCE: 'BACKGROUND_IMAGE_STATIC_RESOURCE',
  BLOCK_FRIEND_REQUESTS: 'BLOCK_FRIEND_REQUESTS',
  BOOST_CAM: 'BOOST_CAM',
  BROADCASTER_AS_VIEWER: 'BROADCASTER_AS_VIEWER',
  BROADCASTER_ONLINE_PROFILE_V2: 'BROADCASTER_ONLINE_PROFILE_V2',
  BROADCASTER_PROFILE_EDIT_LINKS: 'BROADCASTER_PROFILE_EDIT_LINKS',
  BROADCAST_OBS_VIRTUAL_CAMERA_WARNING: 'BROADCAST_OBS_VIRTUAL_CAMERA_WARNING',
  BROADCAST_WHILE_MAIN_ID_PENDING: 'BROADCAST_WHILE_MAIN_ID_PENDING',
  CALENDAR_V2: 'CALENDAR_V2',
  CAM2CAM_BROADCASTER: 'CAM2CAM_BROADCASTER',
  CAM2CAM_VIEWER: 'CAM2CAM_VIEWER',
  CAM4_FAN5: 'CAM4_FAN5',
  CSS_FEEDBACK_WIDGET: 'CSS_FEEDBACK_WIDGET',
  CSS_FEEDBACK_WIDGET_VIEWER: 'CSS_FEEDBACK_WIDGET_VIEWER',
  EXADS_DESKTOP_INTERSTITIAL: 'EXADS_DESKTOP_INTERSTITIAL',
  FAN5_BROADCASTER: 'FAN5_BROADCASTER',
  FAN5_VIEWER: 'FAN5_VIEWER',
  FANCLUB_DIRECTORY: 'FANCLUB_DIRECTORY',
  FAVORITED_YOU_MY_ACCOUNT_V2: 'FAVORITED_YOU_MY_ACCOUNT_V2',
  FINGERPRINT: 'FINGERPRINT',
  GENDER_PREFERENCES_V2: 'GENDER_PREFERENCES_V2',
  GENDER_SPECIFIC_DIRECTORY_FILTERS: 'GENDER_SPECIFIC_DIRECTORY_FILTERS',
  GIFS_IN_PLAYER_CHAT: 'GIFS_IN_PLAYER_CHAT',
  GIFTS_REVAMP: 'GIFTS_REVAMP',
  GOLD_OVERLAY_ONE_PACKAGE: 'GOLD_OVERLAY_ONE_PACKAGE',
  GOOGLE_CAPTCHA: 'GOOGLE_CAPTCHA',
  GOOGLE_CAPTCHA_CREATE_ACCOUNT: 'GOOGLE_CAPTCHA_CREATE_ACCOUNT',
  GOOGLE_CAPTCHA_V3_CREATE_ACCOUNT: 'GOOGLE_CAPTCHA_V3_CREATE_ACCOUNT',
  GOOGLE_CAPTCHA_V3_LOGIN: 'GOOGLE_CAPTCHA_V3_LOGIN',
  HAPPY_HOUR: 'HAPPY_HOUR',
  HIDE_FLAGS_REWRITE_DIRECTORY: 'HIDE_FLAGS_REWRITE_DIRECTORY',
  HLS_TUNED_PARAMETERS: 'HLS_TUNED_PARAMETERS',
  INBOX_REWRITE: 'INBOX_REWRITE',
  JINK_PLAYER: 'JINK_PLAYER',
  KIIROO_CONTROL: 'KIIROO_CONTROL',
  NAKED_NEWS_BUNDLING: 'NAKED_NEWS_BUNDLING',
  OLD_CHROME_IOS_WARNING: 'OLD_CHROME_IOS_WARNING',
  PAXUM_CHANGES: 'PAXUM_CHANGES',
  PREFERRED_ORIGIN_OVERRIDE: 'PREFERRED_ORIGIN_OVERRIDE',
  PREMIUM_PRIVATE_SHOW: 'PREMIUM_PRIVATE_SHOW',
  PRIVATE_DIRECTORY_OFFLINE_REQUESTS: 'PRIVATE_DIRECTORY_OFFLINE_REQUESTS',
  PRIVATE_SHOW_RATINGS: 'PRIVATE_SHOW_RATINGS',
  PROFILES_V2_FEEDBACK_OVERLAY: 'PROFILES_V2_FEEDBACK_OVERLAY',
  PROFILES_V2_FULL_SIZE_GALLERY_THUMBS: 'PROFILES_V2_FULL_SIZE_GALLERY_THUMBS',
  PROFILES_V2_MOBILE_TOKEN_BALANCE_VARIATION: 'PROFILES_V2_MOBILE_TOKEN_BALANCE_VARIATION',
  PROFILES_V2_SPECIAL_SHOW_PUBLIC_CHAT: 'PROFILES_V2_SPECIAL_SHOW_PUBLIC_CHAT',
  PROFILE_CANADA: 'PROFILE_CANADA',
  PROFILE_V2_FORCE_REFRESH: 'PROFILE_V2_FORCE_REFRESH',
  PROFILE_V2_NOT_SINGLE_PAGE_APP: 'PROFILE_V2_NOT_SINGLE_PAGE_APP',
  REALITY_SHOWS: 'REALITY_SHOWS',
  REMOVE_ALL_ADS: 'REMOVE_ALL_ADS',
  SEGMENTED_HOMEPAGE: 'SEGMENTED_HOMEPAGE',
  SIGN_UP_OVERLAY_SHORT_DELAY: 'SIGN_UP_OVERLAY_SHORT_DELAY',
  SOCIALE_PAYOUT: 'SOCIALE_PAYOUT',
  SPECIAL_SHOWS_CHAT_LOCK: 'SPECIAL_SHOWS_CHAT_LOCK',
  STREAMING_SAAS: 'STREAMING_SAAS',
  STREAMING_SAAS_USER_GROUP: 'STREAMING_SAAS_USER_GROUP',
  TEMPTED_FANCLUB: 'TEMPTED_FANCLUB',
  TEST_ORIGIN_OVERRIDE: 'TEST_ORIGIN_OVERRIDE',
  TIP_MENU_2021: 'TIP_MENU_2021',
  TOKEN_AWARENESS_OVERLAY: 'TOKEN_AWARENESS_OVERLAY',
  TRANS_NEW_ATTRIBUTES: 'TRANS_NEW_ATTRIBUTES',
  TRANS_NEW_ATTRIBUTES_OVERLAY: 'TRANS_NEW_ATTRIBUTES_OVERLAY',
  USE_C2C_PRICES: 'USE_C2C_PRICES',
  USE_WEBCHAT_CHAT_HISTORY: 'USE_WEBCHAT_CHAT_HISTORY',
  USER_COUNTRY_DE: 'USER_COUNTRY_DE',
  USER_REPORTED_MESSAGES: 'USER_REPORTED_MESSAGES',
  USE_EWALLET: 'USE_EWALLET',
  USE_OTHER_PROCESSORS: 'USE_OTHER_PROCESSORS',
  USE_TEST_PAYOUT_PROCESSORS: 'USE_TEST_PAYOUT_PROCESSORS',
  USE_WEBRTC_BROADCAST: 'USE_WEBRTC_BROADCAST',
  VIEWER_BROADCAST_FLOW: 'VIEWER_BROADCAST_FLOW',
  DESIGNER_RECRUITMENT_BANNER: 'DESIGNER_RECRUITMENT_BANNER',
  STREAMING_SAAS_WOWZA: 'STREAMING_SAAS_WOWZA',
  TWO_FA_EMAIL_MODAL: 'TWO_FA_EMAIL_MODAL',
  USE_UPCHARGE: 'USE_UPCHARGE',
  CAM2CAM_OBS: 'CAM2CAM_OBS',
  JUICY_SERVICE: 'JUICY_SERVICE',
  CHAT_BOTS: 'CHAT_BOTS',
  DIRECTORY_REDESIGN: 'DIRECTORY_REDESIGN',
  BIRTHDAY_TOKEN_OFFER_10_PERCENT: 'BIRTHDAY_TOKEN_OFFER_10_PERCENT',
  OBS_SETUP_INFO_MODAL: 'OBS_SETUP_INFO_MODAL',
};

export default allUserGroups;
